import React, { useState, Fragment } from "react";
import { useCollectionData } from "react-firebase-hooks/firestore";
import {
  formatDistanceToNow,
  parseISO,
  isFuture,
  formatISO,
  addDays,
} from "date-fns";

import Episode from "./Episode";
import TabPicker from "./tailwind/TabPicker";

export default function Episodes({ db, userDoc, user }) {
  const [showArchive, setShowArchive] = useState(false);

  const episodeCollectionName = "YT:episodes";
  let query = userDoc.collection(episodeCollectionName);

  if (showArchive) query = query.where("stage", "==", "archived");
  else query = query.where("stage", "in", ["", "write", "record", "publish"]);

  // getting a "failed precondition" if I do this
  // query = query.orderBy("date");

  const [episodes, loading, error] = useCollectionData(query, {
    idField: "id",
  });

  if (loading || error)
    return <pre>{JSON.stringify({ loading, error }, null, 2)}</pre>;

  const sortedEpisodes = episodes.sort((a, b) =>
    ("" + a.date).localeCompare("" + b.date)
  );

  const latestDate =
    (sortedEpisodes[sortedEpisodes.length - 1] || {}).date || "2020-03-12";

  const nextDate = formatISO(addDays(parseISO(latestDate), 1), {
    representation: "date",
  });
  //
  return (
    <Fragment>
      <TabPicker
        options={{ upcoming: "Upcoming", archived: "Archived" }}
        activeOption={showArchive ? "archived" : "upcoming"}
        onChange={(tab) => setShowArchive(tab === "archived")}
      />
      {sortedEpisodes.map((episode) => (
        <Episode
          key={episode.id}
          episode={episode}
          onChange={(newEpisode) => {
            userDoc
              .collection(episodeCollectionName)
              .doc("" + newEpisode.id)
              .set(newEpisode);
          }}
          uid={user.uid}
        />
      ))}
      <button
        onClick={() => {
          userDoc
            .collection(episodeCollectionName)
            .doc("" + new Date())
            .set({
              date: nextDate,
              stage: "write",
            });
        }}
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded block"
      >
        ➕ Add {nextDate}
      </button>
    </Fragment>
  );
}
